import Helper from "@ember/component/helper"
import _ from "lodash"

export function startCase(params) {
  return _.startCase(params[0])
}

export default class StartCase extends Helper {
  compute = startCase
}
